export interface UserImageModel {
  type?: UserImageModel.TypeEnum;
  image?: File;
}

export namespace UserImageModel {
  export type TypeEnum =
    'passport_identity_page'
    | 'passport_sign_page'
    | 'passport_registration_page'
    | 'passport_selfie'
    | 'driver_license_front'
    | 'driver_license_back'
    | 'transport_passport_front';
  export const TypeEnum = {
    PassportIdentityPage: 'passport_identity_page' as TypeEnum,
    PassportSignPage: 'passport_sign_page' as TypeEnum,
    PassportRegistrationPage: 'passport_registration_page' as TypeEnum,
    PassportSelfie: 'passport_selfie' as TypeEnum,
    DriverLicenseFront: 'driver_license_front' as TypeEnum,
    DriverLicenseBack: 'driver_license_back' as TypeEnum,
    TransportPassportFront: 'transport_passport_front' as TypeEnum
  };
}
